import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';

import { makeGetTermLinks, makeGetCardTitle } from '../redux';

import removeTags from 'service_modules/utils/text-remove-tags';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

import styles from '../__styles__/ctas.scss?modules';

const Tncs = ({ termLinks, cardTitle, shortName, isBottomRow }) => (
  <div className={styles.tncContainer}>
    {termLinks &&
      termLinks.map(({ data }) => {
        const { html, href } = data;
        const title = removeTags(html);
        const ariaLabel = removeTags(`${html} for ${cardTitle}`);
        const onClick = () =>
          sendDTMClickEvent({
            eventAction: 'Click',
            eventAsset: `OfferTerms_${shortName}`
          });

        return (
          <a
            href={href}
            target="_blank"
            title={title}
            aria-label={ariaLabel}
            onClick={onClick}
            className={clsx(styles.tnc, { [styles.isBottomRow]: isBottomRow })}
            key={ariaLabel}
            rel="noopener noreferrer"
          >
            <Sanitizer safelySetInnerHTML={html} />
          </a>
        );
      })}
  </div>
);

const mapStateToProps = () => {
  const getCardTitle = makeGetCardTitle();
  const getTermLinks = makeGetTermLinks();

  return (state, { shortName }) => ({
    termLinks: getTermLinks(state, shortName),
    cardTitle: getCardTitle(state, shortName)
  });
};

export default connect(mapStateToProps)(Tncs);
